import { Component, OnInit, ViewChild } from '@angular/core';
import { ColorPickerService } from 'ngx-color-picker';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { Subject } from 'rxjs';
import { LoyaltyService } from '../../../../../shared/_services/loyalty.service';
import { MarketingService } from '../../../../../shared/_services/marketing.service';
import { UtilService } from '../../../../../shared/_services/util.service';

@Component({
  selector: 'app-hca-loyalty-programs',
  templateUrl: './hca-loyalty-programs.component.html',
  styleUrls: ['./hca-loyalty-programs.component.scss']
})
export class HcaLoyaltyProgramsComponent implements OnInit {
  currencies: any;
  bookingTypes: any;
  bookingTypesForConsumer: any[] = [];
  bookingTypesForAgents: any[] = [];
  loyalty: FormGroup;
  formData: any;
  loyaltyProgramId: any;
  errorDetails: any;
  successMsg: string;
  employeeMemberProgramType: FormGroup;
  travelAgentMemberType: FormGroup;
  travelAgentType: FormGroup;
  employeeProgramType: FormGroup;
  consumerProgramType: FormGroup;
  consumerMemberProgramType: FormGroup;
  statusModal: BsModalRef;
  selectedBrandIndex: any = 0;
  transactionTypes: any[] = [];
  employeePointRules: any[] = [];
  programTypes: any;
  @ViewChild('consumerProgram') consumerProgramEle: any;
  @ViewChild('employeeProgram') employeeProgramEle: any;
  @ViewChild('travelAgent') travelAgentEle: any;
  @ViewChild('consumerContentProgram') consumerContentProgramEle: any;
  @ViewChild('employeeContentProgram') employeeContentProgramEle: any;
  @ViewChild('travelContentAgent') travelContentAgentEle: any;

  @ViewChild('consumerMemberProgram') consumerMemberProgramEle: any;
  @ViewChild('employeeMemberProgram') employeeMemberProgramEle: any;
  @ViewChild('travelAgentMember') travelAgentMemberEle: any;
  @ViewChild('consumerMemberContentProgram') consumerMemberContentProgramEle: any;
  @ViewChild('employeeMemberContentProgram') employeeMemberContentProgramEle: any;
  @ViewChild('travelAgentContentMember') travelAgentContentMemberEle: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  isInit: any;
  constructor(
    private fb: FormBuilder,
    private validationService: ValidationService,
    private cpService: ColorPickerService,
    private marketingService: MarketingService,
    private modalService: BsModalService,
    private utilService: UtilService,
    private loyaltyService: LoyaltyService,
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "hca-remove") {
              const form = this.statusModal.content.srcObject.form;
              const control = this.statusModal.content.srcObject.control;
              const i = this.statusModal.content.srcObject.i;
              const type = this.statusModal.content.srcObject.type2;
              this.removeControl(form, control, i, type);
            }
          }
        }
      })
  }
  addMembershipLevel(membershipData?: any, formCtrl?) {
    let memberShipForm = this[formCtrl].get('membershipLevelToList') as FormArray;
    let perksArray = new FormArray([]);
    if(membershipData && membershipData.perkConfig && membershipData.perkConfig.length) {
      membershipData.perkConfig.forEach(perk => {
        perksArray.push(this.addPerks(perk));
      });
    } else {
      [1, 2, 3, 4].forEach(perk => {
        perksArray.push(this.addPerks(null));
      })
    }
    memberShipForm.push(this.fb.group({
      memberShipName: [membershipData ? membershipData.memberShipName : '', [Validators.required,]],
      memberShipLevel: [membershipData ? membershipData.memberShipLevel : '', Validators.required],
      costToJoin: [membershipData ? membershipData.costToJoin : null, Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)],
      pointsGrantedPercentage: [membershipData ? membershipData.pointsGrantedPercentage : null, Validators.pattern(this.validationService.isNumber_regexPattern)],
      exchangeRatePointsGranted: [membershipData ? membershipData.exchangeRatePointsGranted : null, Validators.pattern(this.validationService.isNumber_regexPattern)],
      maxDiscountPercentage: [membershipData ? membershipData.maxDiscountPercentage : null, Validators.pattern(this.validationService.isNumber_regexPattern)],
      exchangeRatePointsExpended: [membershipData ? membershipData.exchangeRatePointsExpended : null, Validators.pattern(this.validationService.isNumber_regexPattern)],
      coeficient: [membershipData ? membershipData.coeficient : null, Validators.pattern(this.validationService.isNumber_regexPattern)],
      costOfBookings: [membershipData ? membershipData.costOfBookings : null, Validators.pattern(this.validationService.isNumber_regexPattern)],
      costOfExtras: [membershipData ? membershipData.costOfExtras : null, Validators.pattern(this.validationService.isNumber_regexPattern)],
      currencyType: [membershipData && membershipData.currencyType ? membershipData.currencyType.currencyId : null],
      isCostToJoin: [membershipData ? membershipData.isCostToJoin : '', Validators.required],
      isGuestOptIn: [membershipData ? membershipData.isGuestOptIn : '', Validators.required],
      noOfNightsNeedToUpgrade: [membershipData ? membershipData.noOfNightsNeedToUpgrade : '', Validators.required],
      noOfPointsIssuedOnEnrolling: [membershipData ? membershipData.noOfPointsIssuedOnEnrolling : '', Validators.required],
      noOfStaysNeedToUpgrade: [membershipData ? membershipData.noOfStaysNeedToUpgrade : '', Validators.required],
      colourCode: [membershipData ? membershipData.colourCode : '', Validators.required],
      perkConfig: perksArray,
      // noOfPointsIssuedOnReferral: [membershipData ? membershipData.noOfPointsIssuedOnReferral : '', Validators.required]
    }, this.validationService.minLengthArray(1)))
  }

  addPerks(perkData?: any) {
    // let perkForm = new FormArray([]);
    return new FormControl(perkData ? perkData : null, Validators.required);
  }

  onColorPickerChange(colourCode: string, formControl, index): void {
    let memberShipForm = this[formControl].get('membershipLevelToList') as FormArray;
    memberShipForm.at(index).get('colourCode').setValue(colourCode);
    memberShipForm.at(index).get('colourCode').markAsDirty();
    memberShipForm.at(index).get('colourCode').markAsTouched();
  }

  remove(form, control, i, type2?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-remove',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to remove membership?',
      action1: 'Remove',
      action2: 'Cancel',
      action: '',
      style: 'inactive',
      form: form,
      control: control,
      i: i,
      type2: type2
    }
  }


  // fetching remote data functions
  updateLoyalty(from?, to?) {
    this.formData = {
      programmeName: this.loyalty.value.programmeName,
      programId: this.loyaltyProgramId,
      programTypeList: [],
      // brandsList: [],
      // adminsList: []
    }

    if(from == 'doneStep1'){
      document.querySelector('wizard-navigation-bar ul.steps-indicator li').classList.add('step-done');
    }


    if (from == 'saveLoyalty') {
      this.consumerProgramType.value.bookingTypeList = [];
      this.travelAgentType.value.bookingTypeList = [];
      this.employeeProgramType.value.bookingTypeList = [{
        costOfBooking: this.employeeProgramType.value.costOfBooking,
        pointsRuleId: this.employeeProgramType.value.pointsRuleId,
        referralPoints: this.employeeProgramType.value.referralPoints,
        bookingTypeTo: null
      }];
      


      this.consumerProgramType.value.membershipLevelToList = [];
      this.employeeProgramType.value.membershipLevelToList = [];
      this.travelAgentType.value.membershipLevelToList = [];
      //bookings
      this.loyalty.controls['bookingType'].value.forEach(bookingValue => {
        if (bookingValue == 1) {
          //direct bookings

          //consumer
          this.consumerProgramType.value.directBooking = this.consumerProgramType.value.directBooking.bookingTypeTo 
            ? 
            this.consumerProgramType.value.directBooking 
            : 
            Object.assign(this.consumerProgramType.value.directBooking.points, this.consumerProgramType.value.directBooking.guests);
          
          this.consumerProgramType.value.directBooking.bookingTypeTo = {
            bookingType: "Direct",
            bookingTypeId: 1
          };

          if(this.consumerProgramType.value.bookingTypeList.length === 0) {
            this.consumerProgramType.value.bookingTypeList.push(this.consumerProgramType.value.directBooking);
          }
          

          //agent

          this.travelAgentType.value.directBooking = this.travelAgentType.value.directBooking.bookingTypeTo 
            ? 
            this.travelAgentType.value.directBooking
            : 
            Object.assign(this.travelAgentType.value.directBooking.points, this.travelAgentType.value.directBooking.guests);
          
          //console.log("3 (result)"+JSON.stringify(this.travelAgentType.value.directBooking))
         // console.log("4 "+JSON.stringify( Object.assign(this.travelAgentType.value.directBooking.points, this.travelAgentType.value.directBooking.guests)))
          this.travelAgentType.value.directBooking.bookingTypeTo = {
              bookingType: "Direct",
              bookingTypeId: 1
          };

          if(this.travelAgentType.value.bookingTypeList.length === 0) {
            this.travelAgentType.value.bookingTypeList.push(this.travelAgentType.value.directBooking);
          }
          //console.log("size of bookingType on agent "+this.travelAgentType.value.bookingTypeList.length)
          //console.log("bookingType on agent "+JSON.stringify(this.travelAgentType.value.bookingTypeList))
        }
        if (bookingValue == 2) {
          //external bookings
          this.consumerProgramType.value.externalBooking = this.consumerProgramType.value.externalBooking.bookingTypeTo 
            ? 
            this.consumerProgramType.value.externalBooking 
            : 
            Object.assign(this.consumerProgramType.value.externalBooking.points, this.consumerProgramType.value.externalBooking.guests);
          
            this.consumerProgramType.value.externalBooking.bookingTypeTo = {
            bookingType: "External",
            bookingTypeId: 2
          };
          //consumer
          this.consumerProgramType.value.bookingTypeList.push(this.consumerProgramType.value.externalBooking);
        }
      })
      //membership data
      this.consumerProgramType.value.membershipLevelToList = this.utilService.cleanArray(this.consumerMemberProgramType.value.membershipLevelToList.map(member => {
        if (member.isCostToJoin) {
          member.currencyType = this.currencies.filter(currency => currency.currencyId == member.currencyType)[0];
          return member;
        } else {
          member.currencyType = null;
          return member;
        }
      }))
      this.employeeProgramType.value.membershipLevelToList = this.utilService.cleanArray(this.employeeMemberProgramType.value.membershipLevelToList.map(member => {
        if (member.isCostToJoin) {
          member.currencyType = this.currencies.filter(currency => currency.currencyId == member.currencyType)[0];
          return member;
        } else {
          return member;
        }
      }));
      this.travelAgentType.value.membershipLevelToList = this.utilService.cleanArray(this.travelAgentMemberType.value.membershipLevelToList.map(member => { 
        if (member.isCostToJoin) {
          member.currencyType = this.currencies.filter(currency => currency.currencyId == member.currencyType)[0];
          return member;
        } else {
          return member;
        }
      }));

      this.loyalty.controls['programType'].value.forEach(value => {
        if (value == 1) {
          this.formData.programTypeList.push(this.consumerProgramType.value);
        }
        if (value == 2) {
          this.formData.programTypeList.push(this.employeeProgramType.value);
        }
        if (value == 3) {
          //console.log("Travel Agent for save "+ JSON.stringify(this.travelAgentType.value))
          this.formData.programTypeList.push(this.travelAgentType.value);
        }
      })
      
      //console.log("All form data for send "+ JSON.stringify(this.formData))
      
      // this.formData.brandsList = this.loyaltyBrand.value.brandsList;
      // this.formData.adminsList = this.loyaltyAdmin.value.adminsList;
      
      this.loyaltyService.updateLoyalty(this.formData).subscribe(res => {
        this.successMsg = 'Loyalty Program updated successfully';
        setTimeout(() => {
          this.successMsg = '';
        }, 2500);
      }, err => {
        this.errorDetails = err.message ? err.message : 'Error while updating Loyalty Program';
        setTimeout(() => {
          this.errorDetails = '';
        }, 2500);
      }) 

    }
  }

  getLoyaltyProgram() {
    this.loyaltyService.getLoyaltyProgram().subscribe(res => {
      if (res.error == 0) {
        this.loyaltyProgramId = res.responseObj.programId;
        this.programTypes = res.responseObj;
        if(res.responseObj) {
          this.initLoyalty1Form(res.responseObj);
          res.responseObj.programTypeList.forEach(program => {
            this.addFormControl('programType', {loyaltyProgramTypeId: program.programTypeId}, true, true);
            if(program.programTypeId == 1) {
              program.bookingTypeList.forEach(booking => {
                let pointsArr = ['coeficient', 'costOfBooking', 'costOfExtras'];
                let ignorePointsArr = ['pointsRuleId', 'referralPoints'];
                if(booking.bookingTypeTo) {
                  this.addFormControl('bookingType', {bookingTypeId: booking.bookingTypeTo ? booking.bookingTypeTo.bookingTypeId: null}, true, true);
                  if(booking.bookingTypeTo.bookingTypeId == 1) {
                    Object.keys(booking).forEach(value => {
                         if(value != 'bookingTypeTo' && pointsArr.indexOf(value) > -1) {
                            this.consumerProgramType.get('directBooking').get('points').get(value).patchValue(booking[value], {emitEvent: false});
                          }
                          if(value != 'bookingTypeTo' && pointsArr.indexOf(value) == -1 && ignorePointsArr.indexOf(value) == -1 && this.consumerProgramType.get('directBooking')) {
                            this.consumerProgramType.get('directBooking').get('guests').get(value).patchValue(booking[value], {emitEvent: false});
                          }
                    })
                  }
                  if(booking.bookingTypeTo.bookingTypeId == 2) {
                    Object.keys(booking).forEach(value => {
                         if(value != 'bookingTypeTo' && pointsArr.indexOf(value) > -1) {
                            this.consumerProgramType.get('externalBooking').get('points').get(value).patchValue(booking[value], {emitEvent: false});
                          }
                          if(value != 'bookingTypeTo' && pointsArr.indexOf(value) == -1 && ignorePointsArr.indexOf(value) == -1) {
                            this.consumerProgramType.get('externalBooking').get('guests').get(value).patchValue(booking[value], {emitEvent: false});
                          }
                    })
                  }
                  this.bookingTypesForConsumer.push(booking.bookingTypeTo)
                }

              })
              this.subscribeBookingTypeChanges();
              this.consumerProgramType.patchValue(program, {emitEvent: false});
              program.membershipLevelToList.forEach((membership, i) => {
                //console.log("Membership for consumer "+ JSON.stringify(membership))
                this.addMembershipLevel(membership, 'consumerMemberProgramType');
                if(membership.currencyType) {
                  this.subscribeMemeberCostChanges(membership.currencyType, 'consumerMemberProgramType', i);
                  membership.currencyType.currencyId = membership.currencyType.currencyId.toString();
                }
              })

              if(this.transactionTypes) {
                this.setTransactionData('consumerProgramType', program);
                // let transactionForm = this.consumerProgramType.get('transactionTypesData') as FormArray;
                // while (transactionForm.controls.length !== 0) {
                //   transactionForm.removeAt(0)
                // }
                // if(!program.transactionTypesData.length) {
                //   this.transactionTypes.forEach(data => {

                //     transactionForm.push(this.fb.group({
                //       id: [data ? data.id : null],
                //       points: [data ? data.points : null],
                //       isEnabled: [data ? data.isEnabled : null],
                //       transactionTypeEn: [data ? data.transactionTypeEn : null],
                //       transactionTypeEs: [data ? data.transactionTypeEs : null],
                //     }));
                //   });
                // } else {
                //   this.transactionTypes.forEach(data => {
                //     program.transactionTypesData.forEach(type => {
                //       if(data.id == type.id) {
                //         let transactionForm = this.consumerProgramType.get('transactionTypesData') as FormArray;
                //         transactionForm.push(this.fb.group({
                //           id: [data ? data.id : null],
                //           points: [type ? type.points : null],
                //           isEnabled: [type && type.points ? true : data ? data.isEnabled : null],
                //           transactionTypeEn: [data ? data.transactionTypeEn : null],
                //           transactionTypeEs: [data ? data.transactionTypeEs : null],
                //         }));
                //       }
                //     });
                //   });
                // }
              }
            }
            if(program.programTypeId == 2) {
              this.employeeProgramType.get('costOfBooking').patchValue(program.bookingTypeList[0].costOfBooking, {emitEvent: false});
              this.employeeProgramType.get('pointsRuleId').patchValue(program.bookingTypeList[0].pointsRuleId, {emitEvent: false});
              this.employeeProgramType.get('referralPoints').patchValue(program.bookingTypeList[0].referralPoints, {emitEvent: false});
              this.employeeProgramType.patchValue(program, {emitEvent: false});
              // program.membershipLevelToList.forEach(membership =>{
              //   this.employeeMemberProgramType.get('noOfPointsIssuedOnEnrolling').patchValue(membership.noOfPointsIssuedOnEnrolling);
              //   // this.employeeMemberProgramType.get('noOfPointsIssuedOnReferral').patchValue(membership.noOfPointsIssuedOnReferral);
              // })

              program.membershipLevelToList.forEach((membership, i) =>{
                this.addMembershipLevel(membership, 'employeeMemberProgramType');
                if(membership.currencyType) {
                  this.subscribeMemeberCostChanges(membership.currencyType, 'employeeMemberProgramType', i);
                  membership.currencyType.currencyId = membership.currencyType.currencyId.toString();
                }
              })
              const programTypeCtrl = (<any>this.loyalty).controls.programType;
              this.setMembershipValidators(programTypeCtrl.value);

              if(this.transactionTypes) {
                this.setTransactionData('employeeProgramType', program);
              }
            }
            if(program.programTypeId == 3) {
              this.travelAgentType.get('costOfBooking').patchValue(program.bookingTypeList[0].costOfBooking, {emitEvent: false});
              this.travelAgentType.patchValue(program, {emitEvent: false});
              program.membershipLevelToList.forEach(membership =>{
                this.travelAgentMemberType.get('noOfPointsIssuedOnEnrolling').patchValue(membership.noOfPointsIssuedOnEnrolling);
                // this.travelAgentMemberType.get('noOfPointsIssuedOnReferral').patchValue(membership.noOfPointsIssuedOnReferral);
              })
              program.bookingTypeList.forEach(booking => {
                let pointsArr = ['coeficient', 'costOfBooking', 'costOfExtras'];
                let ignorePointsArr = ['pointsRuleId', 'referralPoints'];
                if(booking.bookingTypeTo) {
                  this.addFormControl('bookingType', {bookingTypeId: booking.bookingTypeTo ? booking.bookingTypeTo.bookingTypeId: null}, true, true);
                  if(booking.bookingTypeTo.bookingTypeId == 1) {
                    Object.keys(booking).forEach(value => {
                         if(value != 'bookingTypeTo' && pointsArr.indexOf(value) > -1) {
                            this.travelAgentType.get('directBooking').get('points').get(value).patchValue(booking[value], {emitEvent: false});
                          }
                          if(value != 'bookingTypeTo' && pointsArr.indexOf(value) == -1 && ignorePointsArr.indexOf(value) == -1 && this.travelAgentType.get('directBooking')) {
                            this.travelAgentType.get('directBooking').get('guests').get(value).patchValue(booking[value], {emitEvent: false});
                          }
                    })
                  }
                  this.bookingTypesForAgents.push(booking.bookingTypeTo)
                }

              })
              this.subscribeBookingTypeChanges();
              this.travelAgentType.patchValue(program, {emitEvent: false});
              program.membershipLevelToList.forEach((membership, i) => {
                //console.log("Membership for agent"+ JSON.stringify(membership))
                this.addMembershipLevel(membership, 'travelAgentMemberType');
                if(membership.currencyType) {
                  this.subscribeMemeberCostChanges(membership.currencyType, 'travelAgentMemberType', i);
                  membership.currencyType.currencyId = membership.currencyType.currencyId.toString();
                }
              })

              if(this.transactionTypes) {
                this.setTransactionData('travelAgentType', program);
              }
            }



          })
        }
      }
    })
  }

  setTransactionData(ctrl, program) {

    // if(this.transactionTypes) {
      let transactionForm = this[ctrl].get('transactionTypesData') as FormArray;
      while (transactionForm.controls.length !== 0) {
        transactionForm.removeAt(0)
      }
      if(!program.transactionTypesData.length) {
        this.transactionTypes.forEach(data => {
          transactionForm.push(this.fb.group({
            id: [data ? data.id : null],
            points: [data && data.points != 0 ? data.points : null],
            isEnabled: [data ? data.isEnabled : null],
            transactionTypeEn: [data ? data.transactionTypeEn : null],
            transactionTypeEs: [data ? data.transactionTypeEs : null],
          }));
        });
      } else {
        this.transactionTypes.forEach(data => {
          program.transactionTypesData.forEach(type => {
            if(data.id == type.id) {
              let transactionForm = this[ctrl].get('transactionTypesData') as FormArray;
              transactionForm.push(this.fb.group({
                id: [data ? data.id : null],
                points: [type && type.points != 0 ? type.points : null],
                isEnabled: [type && type.points ? true : data ? data.isEnabled : null],
                transactionTypeEn: [data ? data.transactionTypeEn : null],
                transactionTypeEs: [data ? data.transactionTypeEs : null],
              }));
            }
          });
        });
        transactionForm.value.forEach((type, i) => {
          if(type && type.isEnabled) {
            transactionForm.at(i).get('points').setValidators([Validators.required]);
            transactionForm.at(i).get('points').updateValueAndValidity();
          }
        });
      }
    // }
  }

  getBookingTypes() {
    this.loyaltyService.getBookingTypes().subscribe(res => {
      if (res.error == 0) {
        this.bookingTypes = res.responseObj;
      }
    })
  }

  setTransactionTypes(ctrl, data) {
    let transactionForm = this[ctrl].get('transactionTypesData') as FormArray;
    transactionForm.push(this.fb.group({
      id: [data ? data.id : null],
      points: [data ? data.points : null],
      isEnabled: [data ? data.isEnabled : null],
      transactionTypeEn: [data ? data.transactionTypeEn : null],
      transactionTypeEs: [data ? data.transactionTypeEs : null],
    }));
  }

  getTransactionTypes() {
    this.marketingService.getTransactionTypes().subscribe(res => {
      if(res.error == 0) {
        if(res.responseObj && res.responseObj.length) {
          this.transactionTypes = res.responseObj;
        } else {
          this.transactionTypes = [];
        }
      }
    }, err => {
      this.transactionTypes = [];
      console.error('Error while fetching Scratch code: ', err.message);
    })
  }

  getEmployeePointRules() {
    this.loyaltyService.getEmployeePointRules().subscribe(res => {
      if (res.error == 0) {
        if(res.responseObj && res.responseObj.length) {
          this.employeePointRules = res.responseObj;
        } else {
          this.employeePointRules = [];
        }
      }
    }, err => {
      this.employeePointRules = [];
      console.error('Error while fetching Employee Point Rules: ', err.message);
    })
  }

  getCurrencyTypes() {
    this.marketingService.getCurrencyTypes()
      .subscribe(
      res => {
        if (res.error == 0) {
          this.currencies = res.responseObj;
        }
        else {
          console.error("get currency :" + res.message);
        }
      },
      err => {
        console.error(err);
      });
  }


  // update form controls
  setActiveTab(formControl) {
    if(formControl.value.sort().indexOf(1) == 0) {
      this.consumerProgramEle.nativeElement.classList.add('active');
      this.employeeProgramEle.nativeElement.classList.remove('active');
      this.travelAgentEle.nativeElement.classList.remove('active');
      this.consumerContentProgramEle.nativeElement.classList.add('active');
      this.employeeContentProgramEle.nativeElement.classList.remove('active');
      this.travelContentAgentEle.nativeElement.classList.remove('active');

      this.consumerMemberProgramEle.nativeElement.classList.add('active');
      this.employeeMemberProgramEle.nativeElement.classList.remove('active');
      this.travelAgentMemberEle.nativeElement.classList.remove('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.add('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.remove('active');
      this.travelAgentContentMemberEle.nativeElement.classList.remove('active');

    } else if(formControl.value.sort().indexOf(2) == 0) {
      this.consumerProgramEle.nativeElement.classList.remove('active');
      this.employeeProgramEle.nativeElement.classList.add('active');
      this.travelAgentEle.nativeElement.classList.remove('active');
      this.consumerContentProgramEle.nativeElement.classList.remove('active');
      this.employeeContentProgramEle.nativeElement.classList.add('active');
      this.travelContentAgentEle.nativeElement.classList.remove('active');

      this.consumerMemberProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberProgramEle.nativeElement.classList.add('active');
      this.travelAgentMemberEle.nativeElement.classList.remove('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.add('active');
      this.travelAgentContentMemberEle.nativeElement.classList.remove('active');
    } else if(formControl.value.sort().indexOf(3) == 0) {
      this.consumerProgramEle.nativeElement.classList.remove('active');
      this.employeeProgramEle.nativeElement.classList.remove('active');
      this.travelAgentEle.nativeElement.classList.add('active');
      this.consumerContentProgramEle.nativeElement.classList.remove('active');
      this.employeeContentProgramEle.nativeElement.classList.remove('active');
      this.travelContentAgentEle.nativeElement.classList.add('active');

      this.consumerMemberProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberProgramEle.nativeElement.classList.remove('active');
      this.travelAgentMemberEle.nativeElement.classList.add('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.remove('active');
      this.travelAgentContentMemberEle.nativeElement.classList.add('active');
    }
  }

  setPointvalidators(ctrl, key, value) {
    // controls
    const pointsCtrl = (<any>this[ctrl]).controls[key];
    const pointsValueCtrl = (<any>this[ctrl]).controls[value];

    // initialize value changes stream
    const pointsChanges$ = pointsCtrl.valueChanges;
    pointsChanges$.subscribe(point => {
      if (point) {
        pointsValueCtrl.setValidators([Validators.required]);
        pointsValueCtrl.updateValueAndValidity();
      } else {
        pointsValueCtrl.patchValue(null, { emitEvent: false });
        pointsValueCtrl.setValidators(null);
        pointsValueCtrl.updateValueAndValidity();
      }
      // }
    })
  }
  setProgramValidators(ctrl, validateArr, isValidate) {
    const programCtrl = (<any>this[ctrl]);
    if (isValidate) {
      if (ctrl == 'consumerMemberProgramType' || ctrl == 'employeeMemberProgramType') {
        programCtrl.controls['membershipLevelToList'].controls.forEach((key, i) => {
          validateArr.forEach((element, idx) => {
            if(element == 'perkConfig') {
              programCtrl.controls['membershipLevelToList'].at(i).controls[element].controls.forEach(value => {
                value.setValidators([Validators.required]);
                value.updateValueAndValidity();
              })
            }
            programCtrl.controls['membershipLevelToList'].at(i).controls[element].setValidators([Validators.required]);
            programCtrl.controls['membershipLevelToList'].at(i).controls[element].updateValueAndValidity();
          });
        })
      } else {
        validateArr.forEach(key => {
          if (key == 'buyerPoints' || key == 'costOfBooking') {
            programCtrl.controls[key].setValidators([Validators.required, Validators.max(100), Validators.min(0), Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
            programCtrl.controls[key].updateValueAndValidity();
          } else {
            programCtrl.controls[key].setValidators([Validators.required]);
            programCtrl.controls[key].updateValueAndValidity();
          }
        });
      }
    } else {
      if (ctrl == 'consumerMemberProgramType' || ctrl == 'employeeMemberProgramType') {
        if(ctrl == 'consumerMemberProgramType') {
          while (programCtrl.controls['membershipLevelToList'].controls.length !== 0) {
            programCtrl.controls['membershipLevelToList'].removeAt(0)
          }
          if(!this.isInit) {
            this.addMembershipLevel(null, ctrl);
          }
        }
        if(!this.isInit) {
        programCtrl.controls['membershipLevelToList'].controls.forEach((key, i) => {
          // if(i < 0) {
            validateArr.forEach((element, idx) => {
              if(element == 'perkConfig') {
                programCtrl.controls['membershipLevelToList'].at(i).controls[element].controls.forEach(value => {
                  value.setValidators(null);
                  value.updateValueAndValidity();
                })
              }
              programCtrl.controls['membershipLevelToList'].reset();
              programCtrl.controls['membershipLevelToList'].at(0).get('isCostToJoin').patchValue(false, {emitEvent: false});
              programCtrl.controls['membershipLevelToList'].at(0).get('isGuestOptIn').patchValue(false, {emitEvent: false});
              programCtrl.controls['membershipLevelToList'].at(0).get('memberShipLevel').patchValue('Level 1', {emitEvent: false});
              programCtrl.controls['membershipLevelToList'].at(i).controls[element].setValidators(null);
              programCtrl.controls['membershipLevelToList'].at(i).controls[element].updateValueAndValidity();
            });
          // } else {
          //   programCtrl.controls['membershipLevelToList'].removeAt(i);
          // }
        })
      } else {
        programCtrl.controls['membershipLevelToList'].controls.forEach((key, i) => {
          // if(i < 0) {
            validateArr.forEach((element, idx) => {
              if(element == 'perkConfig') {
                programCtrl.controls['membershipLevelToList'].at(i).controls[element].controls.forEach(value => {
                  value.setValidators(null);
                  value.updateValueAndValidity();
                })
              }
              programCtrl.controls['membershipLevelToList'].at(i).controls[element].setValidators(null);
              programCtrl.controls['membershipLevelToList'].at(i).controls[element].updateValueAndValidity();
            });
          // } else {
          //   programCtrl.controls['membershipLevelToList'].removeAt(i);
          // }
        })
      }
      } else {
        validateArr.forEach(key => {
          programCtrl.reset();
          if (ctrl == 'consumerProgramType') {
            programCtrl.get('programTypeName').patchValue('Consumer', { emitEvent: false });
            programCtrl.get('programTypeId').patchValue(1, { emitEvent: false });
          } else if (ctrl == 'employeeProgramType') {
            programCtrl.get('programTypeName').patchValue('Employee', { emitEvent: false });
            programCtrl.get('programTypeId').patchValue(2, { emitEvent: false });
          } else if (ctrl == 'travelAgentType') {
            programCtrl.get('programTypeName').patchValue('Travel Agent', { emitEvent: false });
            programCtrl.get('programTypeId').patchValue(3, { emitEvent: false });
          }
          if (key == 'buyerPoints' || key == 'costOfBooking') {
            programCtrl.controls[key].setValidators(null);
            programCtrl.controls[key].updateValueAndValidity();
          } else {
            programCtrl.controls[key].setValidators(null);
            programCtrl.controls[key].updateValueAndValidity();
          }
        });
      }
    }
  }

  setLoyaltyBookingValidators(isValidate?: boolean) {
    const ctrl = (<any>this.loyalty).controls.bookingType;
    if (isValidate) {
      ctrl.setValidators([Validators.required, this.validationService.minLengthArray(1)]);
      ctrl.updateValueAndValidity();
    } else {
      ctrl.setValidators(null);
      ctrl.updateValueAndValidity();
    }
  }

  setMembershipValidators(programType) {
    if (programType.indexOf(1) > -1 && programType.indexOf(2) > -1 && programType.indexOf(3) > -1) {
      this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], true);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], true);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], true);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient'], true);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
      this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], true);
      this.setLoyaltyBookingValidators(true);
    } else if (programType.indexOf(1) == -1 && programType.indexOf(2) > -1 && programType.indexOf(3) > -1) {
      this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], false);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], true);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], true);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient'], false);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
      this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling'], true);
      this.setLoyaltyBookingValidators(false);
    } else if (programType.indexOf(1) > -1 && programType.indexOf(2) == -1 && programType.indexOf(3) > -1) {
      this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], true);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], false);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], true);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient' ], true);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling', ], true);
      this.setLoyaltyBookingValidators(true);
    } else if (programType.indexOf(1) > -1 && programType.indexOf(2) > -1 && programType.indexOf(3) == -1) {
      this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], true);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], true);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], false);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient'], true);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
      this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling', ], false);
      this.setLoyaltyBookingValidators(true);
    } else if (programType.indexOf(1) == -1 && programType.indexOf(2) == -1 && programType.indexOf(3) > -1) {
      this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], false);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], false);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], true);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient' ], false);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling', ], true);
      this.setLoyaltyBookingValidators(false);
    } else if (programType.indexOf(1) > -1 && programType.indexOf(2) == -1 && programType.indexOf(3) == -1) {
      this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], true);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], false);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], false);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient' ], true);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling',], false);
      this.setLoyaltyBookingValidators(true);
    } else if (programType.indexOf(1) == -1 && programType.indexOf(2) > -1 && programType.indexOf(3) == -1) {
    this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], false);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], true);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], false);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient' ], false);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel'], true);
      this.setProgramValidators('employeeMemberProgramType', ['isCostToJoin', 'isGuestOptIn', 'colourCode', 'perkConfig', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling', ], false);
      this.setLoyaltyBookingValidators(false);
    } else if (programType.indexOf(1) == -1 && programType.indexOf(2) == -1 && programType.indexOf(3) == -1) {
      this.setProgramValidators('consumerProgramType', ['buyerPoints', 'guestPoints', 'expirePoints', 'bookingExpire'], false);
      this.setProgramValidators('employeeProgramType', ['costOfBooking', 'pointsRuleId'], false);
      this.setProgramValidators('travelAgentType', ['costOfBooking'], false);
      this.setProgramValidators('consumerMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade', 'exchangeRatePointsGranted', 'pointsGrantedPercentage', 'exchangeRatePointsExpended', 'maxDiscountPercentage', 'costOfBookings', 'costOfExtras', 'coeficient' ], false);
      this.setProgramValidators('employeeMemberProgramType', ['memberShipName', 'memberShipLevel', 'isCostToJoin', 'isGuestOptIn', 'colourCode', 'noOfNightsNeedToUpgrade', 'noOfPointsIssuedOnEnrolling', 'noOfStaysNeedToUpgrade'], false);
      this.setProgramValidators('travelAgentMemberType', ['noOfPointsIssuedOnEnrolling', ], false);
      this.setLoyaltyBookingValidators(false);
    }
  }

  subscribeProgramTypeChanges() {
    // controls
    const programTypeCtrl = (<any>this.loyalty).controls.programType;

    // initialize value changes stream
    const programTypeChanges$ = programTypeCtrl.valueChanges;

    // subscribe to the stream
    programTypeChanges$.subscribe(programType => {
      this.setMembershipValidators(programType);
    })
  }

  setBookingValidators(key) {
    const bookingCtrl = (<any>this.consumerProgramType).controls[key];
    Object.keys(bookingCtrl.controls).forEach(key => {
      if (key == 'points') {
        Object.keys(bookingCtrl.controls[key].controls).forEach(subKey => {
          bookingCtrl.controls[key].controls[subKey].setValidators([Validators.required, Validators.max(100), Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
          bookingCtrl.controls[key].controls[subKey].updateValueAndValidity();
        });
      } else {
        bookingCtrl.controls[key].setValidators(this.validationService.validateCheckboxes);
        bookingCtrl.controls[key].updateValueAndValidity();
      }
    });
  }

  clearBookingValidators(key) {
    const bookingCtrl = (<any>this.consumerProgramType).controls[key];
    bookingCtrl.reset({ onlySelf: true, emitEvent: false });
    Object.keys(bookingCtrl.controls).forEach(key => {
      if (key == 'points') {
        Object.keys(bookingCtrl.controls[key].controls).forEach(subKey => {
          bookingCtrl.controls[key].controls[subKey].setValidators(null);
          bookingCtrl.controls[key].controls[subKey].updateValueAndValidity();
        });
      } else {
        bookingCtrl.controls[key].setValidators(null);
        bookingCtrl.controls[key].updateValueAndValidity();
      }
    });
  }

  subscribeMemeberCostChanges(value, formCtrl,  i) {
    const formControl = <FormArray>this[formCtrl].controls['membershipLevelToList'];
    if (formControl.at(i).get('isCostToJoin').value) {
      formControl.at(i).get('costToJoin').setValidators([Validators.required, Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
      formControl.at(i).get('currencyType').setValidators([Validators.required]);
      formControl.at(i).get('costToJoin').updateValueAndValidity();
      formControl.at(i).get('currencyType').updateValueAndValidity();
    } else {
      formControl.at(0).get('costToJoin').patchValue(null);
      formControl.at(0).get('currencyType').patchValue(null);
      formControl.at(i).get('costToJoin').setValidators(null);
      formControl.at(i).get('currencyType').setValidators(null);
      formControl.at(i).get('costToJoin').updateValueAndValidity();
      formControl.at(i).get('currencyType').updateValueAndValidity();
    }
  }

  setBookingValidation(loyaltyProgramCtrl?, bookingType?) {
    if (loyaltyProgramCtrl.value.indexOf(1) > -1) {
      if (bookingType.indexOf(1) > -1 && bookingType.indexOf(2) > -1) {
        this.setBookingValidators('directBooking');
        this.setBookingValidators('externalBooking');
      } else if (bookingType.indexOf(1) > -1 && bookingType.indexOf(2) == -1) {
        this.setBookingValidators('directBooking');
        this.clearBookingValidators('externalBooking');
      } else if (bookingType.indexOf(1) == -1 && bookingType.indexOf(2) > -1) {
        this.clearBookingValidators('directBooking');
        this.setBookingValidators('externalBooking');
      } else if (bookingType.indexOf(1) == -1 && bookingType.indexOf(2) == -1) {
        this.clearBookingValidators('directBooking');
        this.clearBookingValidators('externalBooking');
      }
    } else {
      this.clearBookingValidators('directBooking');
      this.clearBookingValidators('externalBooking');
    }
  }

  subscribeBookingTypeChanges() {
    // controls
    const loyaltyBookingCtrl = (<any>this.loyalty).controls.bookingType;
    const loyaltyProgramCtrl = (<any>this.loyalty).controls.programType;

    // initialize value changes stream
    const loyaltyChanges$ = loyaltyBookingCtrl.valueChanges;

    // subscribe to the stream
    loyaltyChanges$.subscribe(bookingType => {
      this.setBookingValidation(loyaltyProgramCtrl, bookingType);
    });
  }

  subscribePointChanges() {
    let validateFormBy = ['consumerProgramType', 'employeeProgramType', 'travelAgentType'];
    let validateInputBy = {
      isBirthdayPoints: 'birthdayPoints',
      isBlogPoints: 'blogPoints',
      isInvitePoints: 'invitePoints',
      isJoinPoints: 'joinPoints',
      isSharePoints: 'sharePoints'
    }

    this.consumerProgramType.controls['buyerPoints'].valueChanges.subscribe((value: any) => {
      let total: any = 100;
      if ((value && value.length == 0) || value == undefined || value == null) {
        this.consumerProgramType.controls['guestPoints'].patchValue(null, { onlySelf: true, emitEvent: false });
      } else if (value > 100) {
        this.consumerProgramType.controls['buyerPoints'].patchValue(100, { onlySelf: true, emitEvent: false });
        this.consumerProgramType.controls['guestPoints'].patchValue(0, { onlySelf: true, emitEvent: false });
      } else {
        let finalVal: any = total - value;
        this.consumerProgramType.controls['guestPoints'].patchValue(Math.round(finalVal * 100) / 100, { onlySelf: true, emitEvent: false });
      }
    })

    this.employeeProgramType.controls['pointsRuleId'].valueChanges.subscribe(value => {
      if(value && (value == 1 || value == 2)) {
        this.employeeProgramType.controls['referralPoints'].setValidators([Validators.required, Validators.max(99999), Validators.min(0), Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
        this.employeeProgramType.controls['referralPoints'].updateValueAndValidity();
      } else {
        this.employeeProgramType.controls['referralPoints'].patchValue(null, { onlySelf: true, emitEvent: false })
        this.employeeProgramType.controls['referralPoints'].setErrors(null, { emitEvent: false })
        this.employeeProgramType.controls['referralPoints'].setValidators(null);
        this.employeeProgramType.controls['referralPoints'].updateValueAndValidity();
      }
    })

    validateFormBy.forEach(ctrl => {
      Object.keys(validateInputBy).forEach(key => {
        this.setPointvalidators(ctrl, key, validateInputBy[key]);
      });
    })
  }

  setTransactionValidations(isChecked? : boolean, ctrl?, idx?) {
    let transactionFormCtrl = <FormArray>this[ctrl].controls['transactionTypesData']
    if(isChecked) {
      // transactionFormCtrl.at(idx).get('isEnabled').patchValue(true, { emitEvent: false });
      transactionFormCtrl.at(idx).get('points').setValidators([Validators.required]);
      transactionFormCtrl.at(idx).get('points').updateValueAndValidity();
    } else {
      // transactionFormCtrl.at(idx).get('isEnabled').patchValue(false, { emitEvent: false });
      transactionFormCtrl.at(idx).get('points').patchValue(null, { emitEvent: false });
      transactionFormCtrl.at(idx).get('points').setValidators(null);
      transactionFormCtrl.at(idx).get('points').updateValueAndValidity();
    }

  }

  // Wizard Form Control  functions
  addFormControl(control, type, isChecked?: boolean, isInit?: boolean) {
    this.isInit = isInit;
    if(control !== 'bookingType') {
      this.consumerProgramEle.nativeElement.classList.remove('active');
      this.employeeProgramEle.nativeElement.classList.remove('active');
      this.travelAgentEle.nativeElement.classList.remove('active');
      this.consumerContentProgramEle.nativeElement.classList.remove('active');
      this.employeeContentProgramEle.nativeElement.classList.remove('active');
      this.travelContentAgentEle.nativeElement.classList.remove('active');

      this.consumerMemberProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberProgramEle.nativeElement.classList.remove('active');
      this.travelAgentMemberEle.nativeElement.classList.remove('active');
      this.consumerMemberContentProgramEle.nativeElement.classList.remove('active');
      this.employeeMemberContentProgramEle.nativeElement.classList.remove('active');
      this.travelAgentContentMemberEle.nativeElement.classList.remove('active');
    }
    const formControl = <FormArray>this.loyalty.controls[control];
    if (isChecked) {
      formControl.push(new FormControl(type[control == 'programType' ? 'loyaltyProgramTypeId' : 'bookingTypeId']));
      formControl.value.sort();
      if(control !== 'bookingType') {
        this.setActiveTab(formControl);
      }
      if (control == 'programType') {
        let typeArray = ['consumerProgramType', 'employeeProgramType', 'travelAgentType'];
        if(type.loyaltyProgramTypeId == 1) {
          this.transactionTypes.forEach(type => {
              this.setTransactionTypes('consumerProgramType', type);
          })
        }
        if(type.loyaltyProgramTypeId == 2) {
          this.transactionTypes.forEach(type => {
              this.setTransactionTypes('employeeProgramType', type);
          })
        }
        if(type.loyaltyProgramTypeId == 3) {
          this.transactionTypes.forEach(type => {
              this.setTransactionTypes('travelAgentType', type);
          })
        }
        this.setActiveTab(formControl);
      }
    } else {
      let bookingTypeForm = <FormArray>this.loyalty.controls['bookingType'];
      if (control == 'programType') {
        if (type.loyaltyProgramTypeId == 1) {
          let consumerForm = <FormArray>this.consumerProgramType.controls['transactionTypesData'];
          while (this.consumerProgramType.controls['transactionTypesData'].value.length !== 0) {
            consumerForm.removeAt(0);
          }
          while (bookingTypeForm.value.length !== 0) {
            bookingTypeForm.removeAt(0)
          }
        }
        if(type.loyaltyProgramTypeId == 2) {
          let employeeForm = <FormArray>this.employeeProgramType.controls['transactionTypesData'];
          while (this.employeeProgramType.controls['transactionTypesData'].value.length !== 0) {
            employeeForm.removeAt(0);
          }
        }
        if(type.loyaltyProgramTypeId == 3) {
          let travelForm = <FormArray>this.travelAgentType.controls['transactionTypesData'];
          while (this.travelAgentType.controls['transactionTypesData'].value.length !== 0) {
            travelForm.removeAt(0);
          }
        }
      }
      let index = formControl.controls.findIndex(x => x.value == type[control == 'programType' ? 'loyaltyProgramTypeId' : 'bookingTypeId']);
      formControl.removeAt(index);
      if(control !== 'bookingType') {
        this.setActiveTab(formControl);
      }
    }
  }

  removeControl(form, control, i, type?) {
    if (type == 'hotel') {
      const formControl = <FormArray>form.controls[control];
      formControl.removeAt(i);
    } else {
      const formControl = <FormArray>this[form].controls[control];
      formControl.removeAt(i);
      this.selectedBrandIndex = 0;
    }
  }

  // init form controls
  initBookingTypes() {
    return this.fb.group({
      points: this.fb.group({
        costOfBooking: [null],
        costOfExtras: [null],
        coeficient: [null]
      }),
      guests: this.fb.group({
        isSeniors: [false],
        isAdults: [false],
        isYouth: [false],
        isChild: [false],
        isInfants: [false]
      })
    })
  }

  initLoyalty1Form(loyalty?: any) {
    this.loyalty = this.fb.group({
      programmeName: [loyalty ? loyalty.programmeName : null, Validators.required],
      programType: this.fb.array([], this.validationService.minLengthArray(1)),
      bookingType: this.fb.array([], this.validationService.minLengthArray(1)),
    })
    //console.log("loyalty form "+ JSON.stringify(this.loyalty))
    //this.logForm(this.loyalty); 
    this.subscribeProgramTypeChanges();
  }

  // Recorre y muestra las propiedades del formulario
  logForm(formGroup: FormGroup) {
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        console.log(`${controlName}: ${formGroup.controls[controlName].value}`);
      }
    }
  }

  initLoyalty2Form(consumerProgramType?: any, employeeProgramType?: any, travelAgentType?: any) {
    this.consumerProgramType = this.fb.group({
      programTypeName: 'Consumer',
      programTypeId: 1,
      directBooking: this.initBookingTypes(),
      externalBooking: this.initBookingTypes(),
      transactionTypesData: new FormArray([]),
      buyerPoints: [null],
      guestPoints: [null],
      pointsRuleId: [null],
      referralPoints: [null],
      isBirthdayPoints: [false],
      birthdayPoints: [null],
      isBlogPoints: [false],
      blogPoints: [null],
      isInvitePoints: [false],
      invitePoints: [null],
      isJoinPoints: [false],
      joinPoints: [null],
      isSharePoints: [false],
      sharePoints: [null],
      expirePoints: [null],
      bookingExpire: [null],
    })

    this.employeeProgramType = this.fb.group({
      programTypeName: 'Employee',
      programTypeId: 2,
      costOfBooking: [null],
      pointsRuleId: [null],
      referralPoints: [null],
      isBirthdayPoints: [false],
      transactionTypesData: new FormArray([]),
      birthdayPoints: [null],
      isBlogPoints: [false],
      blogPoints: [null],
      isInvitePoints: [false],
      invitePoints: [null],
      isJoinPoints: [false],
      joinPoints: [null],
      isSharePoints: [false],
      sharePoints: [null],
      expirePoints: [null],
      bookingExpire: [null],
    })

    this.travelAgentType = this.fb.group({
      programTypeName: 'Travel Agent',
      programTypeId: 3,
      directBooking: this.initBookingTypes(),
      costOfBooking: [null],
      pointsRuleId: [null],
      referralPoints: [null],
      isBirthdayPoints: [false],
      transactionTypesData: new FormArray([]),
      birthdayPoints: [null],
      isBlogPoints: [false],
      blogPoints: [null],
      isInvitePoints: [false],
      invitePoints: [null],
      isJoinPoints: [false],
      joinPoints: [null],
      isSharePoints: [false],
      sharePoints: [null],
      expirePoints: [null],
      bookingExpire: [null],
    })

    // this.subscribeProgramTypeChanges();
    this.subscribePointChanges();
  }

  initLoyalty3Form() {
    let membershipLevelConsumerToList: FormArray = new FormArray([], this.validationService.uniqueBy('memberShipName'));
    let membershipLevelEmpToList: FormArray = new FormArray([], this.validationService.uniqueBy('memberShipName'));
    let membershipLevelTravelToList: FormArray = new FormArray([], this.validationService.uniqueBy('memberShipName'));
    this.consumerMemberProgramType = this.fb.group({
      programNasme: 'Consumer',
      programTypeId: 1,
      membershipLevelToList: membershipLevelConsumerToList
    })
    // this.addMembershipLevel();

    this.employeeMemberProgramType = this.fb.group({
      programNasme: 'Employee',
      programTypeId: 2,
      noOfPointsIssuedOnEnrolling: [null],
      membershipLevelToList: membershipLevelEmpToList
      // noOfPointsIssuedOnReferral: [null]

    })

    this.travelAgentMemberType = this.fb.group({
      programNasme: 'Travel Agent',
      programTypeId: 3,
      noOfPointsIssuedOnEnrolling: [null],
      membershipLevelToList: membershipLevelTravelToList
      // noOfPointsIssuedOnReferral: [null]
    })
  }

  ngOnInit() {
    this.getTransactionTypes();
    this.getLoyaltyProgram();
    this.getEmployeePointRules();
    //this.getBookingTypes();
    this.getCurrencyTypes();
    this.initLoyalty1Form();
    this.initLoyalty2Form();
    this.initLoyalty3Form();
    this.subscribeBookingTypeChanges();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-programs/hca-loyalty-programs.component.ts